<mat-radio-button
  checked="{{ checked }}"
  (change)="radioChange($event)"
  [color]="color"
  [disabled]="disabled"
  [value]="value"
  (click)="clickRadioButton.emit($event)">
  {{ label }}
</mat-radio-button>
